'use client';
import { useState } from 'react';
import type { FAQ } from '@/types';

export default function FAQSection({ faqs }: { faqs: FAQ[] }) {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="space-y-2.5" dir="rtl">
      {faqs.map((faq, i) => {
        const isOpen = open === i;
        return (
          <div key={faq.id} className="rounded-2xl overflow-hidden"
            style={{
              border: `1.5px solid ${isOpen ? '#bfdbfe' : '#e8edf5'}`,
              background: '#fff',
              boxShadow: isOpen ? '0 6px 22px rgba(13,71,161,.10)' : '0 1px 3px rgba(0,0,0,.04)',
              transition: 'border-color .2s, box-shadow .2s',
            }}>
            <button onClick={() => setOpen(isOpen ? null : i)}
              className="w-full text-right flex items-center justify-between gap-3 px-4 py-4"
              style={{ cursor: 'pointer', background: 'none', border: 'none', fontFamily: 'inherit' }}>
              <span className="font-bold" style={{ fontSize: 15, color: isOpen ? '#0d47a1' : '#0f172a', lineHeight: 1.5 }}>
                {faq.question}
              </span>
              <span className="flex-shrink-0 flex items-center justify-center rounded-full"
                style={{
                  width: 28, height: 28,
                  background: isOpen ? '#0d47a1' : '#eff6ff',
                  color: isOpen ? '#fff' : '#0d47a1',
                  fontSize: 20, fontWeight: 700, lineHeight: 1,
                  transform: isOpen ? 'rotate(45deg)' : 'none',
                  transition: 'transform .25s ease, background .2s',
                }}>
                +
              </span>
            </button>
            <div style={{ maxHeight: isOpen ? 600 : 0, overflow: 'hidden', transition: 'max-height .32s ease' }}>
              <p className="px-4 pb-4 leading-relaxed" style={{ fontSize: 14, color: '#475569' }}>
                {faq.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
